module.exports = {
  OVERFLOW_BUTTON_TEST_ID: 'headerOverflowButton',
};
